import { swiper as Swiper, swiperSlide as SwiperSlide } from 'vue-awesome-swiper';

// eslint-disable-next-line
import { collapsingWidth } from './constants.scss';

export default {
  components: { Swiper, SwiperSlide },

  mounted() {
    this.enabled = false;

    window.onresize = () => {
      if (window.innerWidth <= parseInt(collapsingWidth, 10)) {
        if (this.enabled) return;
        this.$refs.swiper.swiper.setTranslate(0);
        this.$refs.swiper.swiper.slideTo(1);
        this.enabled = true;
      } else {
        if (!this.enabled) return;
        this.$refs.swiper.swiper.setTranslate(0);
        this.enabled = false;
      }
    };
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        loop: true,
        initialSlide: 1,
        centeredSlides: false,
        keyboardControl: true,
        mousewheelControl: true,

        // default disable slider
        noSwiping: false,
        allowSlidePrev: false,
        allowSlideNext: false,

        breakpoints: {
          [parseInt(collapsingWidth, 10)]: {
            centeredSlides: true,
            noSwiping: true,
            allowSlidePrev: true,
            allowSlideNext: true,
          },
        },
      },
    };
  },
};
